<script module>
  import AppLayout from '../../layouts/AppLayout.svelte'
  export const layout = AppLayout
</script>

<script>
  import { router } from '@inertiajs/svelte'
  import { Button } from '$lib/components/ui/button/index.js'
  import { Input } from '$lib/components/ui/input/index.js'
  import { Card, CardContent, CardFooter } from '$lib/components/ui/card/index.js'
  import ChevronLeftIcon from '@lucide/svelte/icons/chevron-left'

  let { property, errors = {} } = $props()

  // $state is initialised from the prop once — intentional for a form pre-fill.
  // @svelte-ignore state_referenced_locally
  let name = $state(property.name)
  // @svelte-ignore state_referenced_locally
  let street_address = $state(property.street_address ?? '')
  // @svelte-ignore state_referenced_locally
  let city = $state(property.city ?? '')
  // @svelte-ignore state_referenced_locally
  let postcode = $state(property.postcode ?? '')
  // @svelte-ignore state_referenced_locally
  let state = $state(property.state ?? '')
  let submitting = $state(false)

  function handleSubmit(e) {
    e.preventDefault()
    if (submitting) return
    submitting = true
    router.patch(`/properties/${property.id}`, { property: { name, street_address, city, postcode, state } }, {
      onFinish: () => { submitting = false }
    })
  }
</script>

<svelte:head>
  <title>Edit Property — MyRentalTax</title>
</svelte:head>

<div class="p-5 sm:p-8 flex flex-col gap-5 sm:gap-6 max-w-2xl mx-auto w-full">
  <!-- Page header -->
  <div class="flex items-start justify-between gap-4">
    <div class="flex flex-col gap-1">
      <h1 class="text-xl sm:text-2xl font-bold text-zinc-900 m-0">Edit Property</h1>
      <p class="text-sm text-zinc-500 m-0">{property.name}</p>
    </div>
    <Button variant="ghost" href="/properties" class="text-zinc-500 flex-shrink-0">
      <ChevronLeftIcon class="w-4 h-4" />
      Back
    </Button>
  </div>

  <form onsubmit={handleSubmit}>
    <Card class="shadow-none border-zinc-200">
      <CardContent class="px-5 py-5 sm:px-6 flex flex-col gap-4">
        {#if errors.name}
          <div class="bg-red-50 border border-red-200 rounded-md px-3 py-2 text-sm text-red-600">{errors.name[0]}</div>
        {/if}

        <div class="flex flex-col gap-1.5">
          <label for="name" class="text-sm font-medium text-zinc-900">Property Name</label>
          <Input id="name" type="text" placeholder="e.g. Sunway Geo Residences" bind:value={name} required class="h-9" />
        </div>

        <div class="flex flex-col gap-1.5">
          <label for="street_address" class="text-sm font-medium text-zinc-900">Street Address</label>
          <Input id="street_address" type="text" placeholder="e.g. No 12, Jalan PJU 5/1" bind:value={street_address} class="h-9" />
        </div>

        <div class="flex flex-col gap-1.5">
          <label for="city" class="text-sm font-medium text-zinc-900">City</label>
          <Input id="city" type="text" placeholder="e.g. Kota Damansara" bind:value={city} class="h-9" />
        </div>

        <div class="flex gap-4">
          <div class="flex flex-col gap-1.5 flex-1">
            <label for="postcode" class="text-sm font-medium text-zinc-900">Postcode</label>
            <Input id="postcode" type="text" placeholder="e.g. 47810" bind:value={postcode} class="h-9" />
          </div>
          <div class="flex flex-col gap-1.5 flex-1">
            <label for="state" class="text-sm font-medium text-zinc-900">State</label>
            <Input id="state" type="text" placeholder="e.g. Selangor" bind:value={state} class="h-9" />
          </div>
        </div>
      </CardContent>

      <CardFooter class="px-5 pb-5 sm:px-6 sm:pb-6 border-t border-zinc-100 pt-4 flex justify-end gap-2">
        <Button variant="outline" href="/properties">Cancel</Button>
        <Button type="submit" disabled={submitting}>
          {submitting ? 'Saving…' : 'Save Changes'}
        </Button>
      </CardFooter>
    </Card>
  </form>
</div>
